import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Custom send icon for Breeze Assistant until the Trellis icon is updated to
 * one that is more legible.
 */
export const BreezeSendIcon = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("g", {
    transform: "translate(5.8, 6.4)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.0546 0.242598C10.8071 0.0250985 10.4659 -0.0386515 10.1696 0.0813485L1.15089 3.4076C0.644644 3.5651 0.307144 3.96635 0.265894 4.46135C0.228394 4.9076 0.445894 5.3126 0.820894 5.49635C1.20339 5.68385 2.49714 6.3776 3.40089 6.86885C3.52839 6.93635 3.68214 6.9251 3.79839 6.8351L8.05839 3.53885C8.17839 3.45635 8.31714 3.61385 8.21964 3.7226L4.66839 7.6526C4.57464 7.7576 4.55589 7.91135 4.62339 8.0351L6.13464 10.7838C6.31464 11.0651 6.62589 11.2263 6.96714 11.2263C7.01214 11.2263 7.06089 11.2226 7.10589 11.2151C7.61589 11.1513 8.04714 10.7726 8.22714 10.2288L11.3134 1.1126C11.3996 0.793849 11.3021 0.460098 11.0546 0.242598Z",
      fill: "white"
    })
  })
});